import React from 'react';
import PropTypes from 'prop-types';
import {
  FaFileInvoiceDollar,
  FaFileSignature,
  FaFileCode,
  FaInfo,
  FaRegEnvelope,
  FaRegEye,
  FaPaperclip,
} from 'react-icons/fa';
import { listItemMsg } from '@/shared/components/FormattedListValue';
import TranslateService from '@/shared/services/TranslateService';

import MimeIcon from './MimeIcon';

const RegularEmailIcon = () => (
  <FaRegEnvelope
    style={{
      verticalAlign: 'sub',
      marginRight: '5px',
      fontSize: '1.2em',
      marginLeft: '-2.5px',
    }}
  />
);
const EmailAttachmentIcon = () => <FaPaperclip className="file-icon" />;

const renderEmailIcon = document => {
  if (document.emailStatus) {
    const intl = TranslateService.getIntl();
    const statusLabel = intl.formatMessage(listItemMsg('emailstatus', document.emailStatus));

    // sent, but no further updates
    if (document.emailStatus === 1) {
      return (
        <span title={statusLabel}>
          <RegularEmailIcon />
        </span>
      );
    }
    // delivered
    if (document.emailStatus === 2) {
      return (
        <span
          title={statusLabel}
          style={{ display: 'inline-block', position: 'relative', marginRight: '10px' }}
        >
          <FaRegEnvelope
            textAnchor="middle"
            alignmentBaseline="middle"
            style={{
              fontSize: '1.25em',
              position: 'absolute',
              left: '-0.1em',
              bottom: '0em',
            }}
          />
          <FaInfo
            textAnchor="middle"
            alignmentBaseline="middle"
            style={{
              position: 'relative',
              fontSize: '0.8em',
              right: '-1.5px',
              top: '0.1em',
              color: '#5cb85c',
            }}
          />
        </span>
      );
    }

    // opened
    if (document.emailStatus === 3) {
      return (
        <span
          title={statusLabel}
          style={{ display: 'inline-block', position: 'relative', marginRight: '10px' }}
        >
          <svg
            stroke="currentColor"
            fill="currentColor"
            strokeWidth="0"
            viewBox="0 0 512 512"
            textAnchor="middle"
            alignmentBaseline="middle"
            title={statusLabel}
            height="1em"
            width="1em"
            style={{
              fontSize: '1.25em',
              position: 'absolute',
              left: '-0.1em',
              bottom: '0em',
            }}
          >
            <path d="M 256,0 C 212.795,0 175.36306,37.717375 152.66406,55.859375 128.20106,75.309375 21.595625,161.0542 17.515625,164.4082 A 48.004,48.004 0 0 0 0,201.48438 V 464 c 0,26.51 21.49,48 48,48 h 416 c 26.51,0 48,-21.49 48,-48 V 201.50977 a 48,48 0 0 0 -17.41406,-36.99415 c -4.697,-3.883 -111.722,-89.949245 -135.25,-108.656245 C 337.23194,38.191375 299.437,0 256,0 Z m 0,48 c 23.693,0 55.85716,31.368672 73.41016,45.388672 23.573,18.740998 116.50223,93.493408 132.36523,106.316408 A 5.99,5.99 0 0 1 464,204.36719 V 458 a 6,6 0 0 1 -6,6 H 54 a 6,6 0 0 1 -6,-6 V 204.34766 c 0,-1.813 0.816564,-3.52702 2.226562,-4.66602 C 66.096564,186.86764 159.01884,112.12767 182.58984,93.388672 200.75484,78.879672 232.398,48 256,48 Z" />
          </svg>

          <FaRegEye
            textAnchor="middle"
            alignmentBaseline="middle"
            style={{
              position: 'relative',
              fontSize: '0.8em',
              right: '-1.56px',
              top: '0.3em',
              color: '#5cb85c',
            }}
          />
        </span>
      );
    }

    // delivery failed
    if (document.emailStatus === 4) {
      return (
        <span
          title={statusLabel}
          style={{ display: 'inline-block', position: 'relative', marginRight: '10px' }}
        >
          <FaRegEnvelope
            textAnchor="middle"
            alignmentBaseline="middle"
            style={{
              fontSize: '1.25em',
              position: 'absolute',
              left: '-0.1em',
              bottom: '0em',
            }}
          />
          <FaInfo
            textAnchor="middle"
            alignmentBaseline="middle"
            className="red"
            style={{
              position: 'relative',
              fontSize: '0.8em',
              right: '-1.5px',
              top: '0.1em',
            }}
          />
        </span>
      );
    }
    return <RegularEmailIcon />;
  }
  return <RegularEmailIcon />;
};

const FileIcon = props => {
  const { document } = props;

  if (document.documentType && document.documentType >= 0) {
    switch (document.documentType) {
      // Invoices
      case 0:
      case 4:
      case 6:
        return <FaFileInvoiceDollar className="file-icon text-danger" />;
      // Email
      case 8:
      case 23:
        return renderEmailIcon(document);
      // email attachment
      case 9:
        return <EmailAttachmentIcon />;
      // Eid
      case 10:
        return <FaFileCode className="file-icon" />;
      default:
        return <MimeIcon mime={document.mime} />;
    }
  }

  return <MimeIcon mime={document.mime} />;
};

FileIcon.propTypes = {
  document: PropTypes.shape({}).isRequired,
};

export default FileIcon;
